"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueRenderer = exports.input = exports.iconWrap = exports.icon = void 0;
var _core = require("@emotion/core");
var _feBrary = require("@domain-group/fe-brary");
var _variables = require("./variables");
var textInputStyles = /*#__PURE__*/(0, _core.css)("width:100%;max-width:100%;padding:", _variables.inputVPadding, "px ", _variables.inputHPadding, "px;border:", _variables.inputBorder, ";border-radius:", _variables.inputBorderRadius, ";", (0, _feBrary.applyFont)(_variables.inputFont), ";color:", _variables.inputTextColor, ";min-width:0;appearance:none;");
var floatingLabel = /*#__PURE__*/(0, _core.css)("padding-top:", _variables.floatingPaddingTop, "px;padding-bottom:", _variables.floatingPaddingBottom, "px;");
var _ref = {
  name: "19t2ho9",
  styles: "display:flex;align-items:stretch;"
};
var _ref2 = {
  name: "79elbk",
  styles: "position:relative;"
};
var iconWrap = _ref12 => {
  var iconAppearance = _ref12.iconAppearance;
  return /*#__PURE__*/(0, _core.css)("position:relative;", iconAppearance === 'outside' ? _ref : _ref2);
};
exports.iconWrap = iconWrap;
var iconFirstChildInputFirstChild = {
  name: "tsqr3a",
  styles: "border-top-right-radius:0;border-bottom-right-radius:0;"
};
var iconLastChildInputLastChild = {
  name: "fu3wfu",
  styles: "border-top-left-radius:0;border-bottom-left-radius:0;"
};
var _ref3 = {
  name: "260zpl",
  styles: "left:0;"
};
var _ref4 = {
  name: "19zs6va",
  styles: "right:0;"
};
var icon = _ref13 => {
  var appearance = _ref13.appearance,
    iconAppearance = _ref13.iconAppearance,
    iconPosition = _ref13.iconPosition,
    isDisabled = _ref13.isDisabled,
    hasIcon = _ref13.hasIcon,
    isInputFirstChild = _ref13.isInputFirstChild;
  return /*#__PURE__*/(0, _core.css)("display:flex;align-items:center;padding:0 ", _variables.inputHPadding, "px;", appearance === 'small' && /*#__PURE__*/(0, _core.css)((0, _feBrary.applyFont)(_variables.inputSmallFont), ";padding:0 ", _variables.inputSmallHPadding, "px;"), " ", isDisabled && /*#__PURE__*/(0, _core.css)("color:", _feBrary.tokens.colors.neutral.heavy.disabled, ";"), " ", iconAppearance === 'outside' ? /*#__PURE__*/(0, _core.css)("background:", _feBrary.tokens.colors.neutral.surface.default, ";color:", _feBrary.tokens.colors.neutral.base.default, ";border:", _variables.inputBorder, ";border-radius:", _variables.inputBorderRadius, ";", hasIcon && !isInputFirstChild && /*#__PURE__*/(0, _core.css)("border-right:0;", iconFirstChildInputFirstChild, ";"), " ", hasIcon && isInputFirstChild && /*#__PURE__*/(0, _core.css)("border-left:0;", iconLastChildInputLastChild)) : /*#__PURE__*/(0, _core.css)("position:absolute;top:0;bottom:0;z-index:2;", iconPosition === 'left' ? _ref3 : _ref4));
};
exports.icon = icon;
var _ref5 = {
  name: "1k07npk",
  styles: "border-radius:0;"
};
var _ref6 = {
  name: "fu3wfu",
  styles: "border-top-left-radius:0;border-bottom-left-radius:0;"
};
var _ref7 = {
  name: "tsqr3a",
  styles: "border-top-right-radius:0;border-bottom-right-radius:0;"
};
var _ref8 = {
  name: "q7lffx",
  styles: "opacity:0;"
};
var _ref9 = {
  name: "qcqkus",
  styles: "padding-left:40px;"
};
var _ref10 = {
  name: "19xhq27",
  styles: "padding-right:40px;"
};
var input = _ref14 => {
  var isInvalid = _ref14.isInvalid,
    appearance = _ref14.appearance,
    isUsingValueRenderer = _ref14.isUsingValueRenderer,
    iconAppearance = _ref14.iconAppearance,
    iconPosition = _ref14.iconPosition,
    hasFloatingLabel = _ref14.hasFloatingLabel,
    isInputFirstChild = _ref14.isInputFirstChild,
    isInputLastChild = _ref14.isInputLastChild,
    resize = _ref14.resize;
  return /*#__PURE__*/(0, _core.css)(textInputStyles, ";", !isInputFirstChild && !isInputLastChild && _ref5, " ", isInputLastChild && !isInputFirstChild && _ref6, " ", !isInputLastChild && isInputFirstChild && _ref7, " background:", _feBrary.tokens.colors.neutral.surface.default, ";transition:150ms border-color ease-in,150ms color ease-in,150ms box-shadow ease-in;", isUsingValueRenderer && _ref8, " &::placeholder{color:", _variables.inputPlaceholderTextColor, ";font-style:normal;}&:hover{border-color:", _variables.inputHoverBorderColor, ";}&:focus{border-color:", _variables.inputFocusBorderColor, ";outline:none;color:", _variables.inputFocusTextColor, ";box-shadow:inset 0 0 0 1px ", _variables.inputFocusBorderColor, ";opacity:1;}&:disabled{border-color:", _variables.inputBorderColor, ";background-color:", _variables.inputDisabledBackgroundColor, ";&,&::placeholder{color:", _feBrary.tokens.colors.neutral.base.disabled, ";}}", isInvalid && /*#__PURE__*/(0, _core.css)("border-color:", _variables.inputErrorBorderColor, ";&:focus{border-color:", _variables.inputErrorBorderColor, ";box-shadow:inset 0 0 0 1px ", _variables.inputErrorBorderColor, ";}&,&:disabled{border-color:", _variables.inputErrorBorderColor, ";&:focus{box-shadow:inset 0 0 0 1px ", _variables.inputErrorBorderColor, ";}}"), " ", appearance === 'small' && /*#__PURE__*/(0, _core.css)((0, _feBrary.applyFont)(_variables.inputSmallFont), ";padding:", _variables.inputSmallVPadding, " ", _variables.inputSmallHPadding, ";"), " ", iconAppearance === 'inside' && (iconPosition === 'left' ? _ref9 : _ref10), " ", !isInputLastChild && /*#__PURE__*/(0, _core.css)(iconFirstChildInputFirstChild), " ", hasFloatingLabel && /*#__PURE__*/(0, _core.css)(floatingLabel, ";"), " ", resize && /*#__PURE__*/(0, _core.css)("resize:", resize, ";"));
};
exports.input = input;
var _ref11 = {
  name: "1u6u1z0",
  styles: "border-bottom-left-radius:0;border-top-left-radius:0;"
};
var valueRenderer = _ref15 => {
  var isInvalid = _ref15.isInvalid,
    isDisabled = _ref15.isDisabled,
    isHidden = _ref15.isHidden,
    isDisplayingPlaceholder = _ref15.isDisplayingPlaceholder,
    hasIconLeft = _ref15.hasIconLeft,
    iconPosition = _ref15.iconPosition,
    iconAppearance = _ref15.iconAppearance,
    hasFloatingLabel = _ref15.hasFloatingLabel;
  return /*#__PURE__*/(0, _core.css)(textInputStyles, ";position:absolute;left:0;right:0;top:0;bottom:0;z-index:1;pointer-events:none;overflow:hidden;white-space:nowrap;background-color:", _feBrary.tokens.colors.neutral.surface.default, ";box-shadow:inset 0 0 0 1px transparent;", isInvalid && /*#__PURE__*/(0, _core.css)("border-color:", _variables.inputErrorBorderColor, ";"), " ", isDisabled && /*#__PURE__*/(0, _core.css)("border-color:", _variables.inputBorderColor, ";background-color:", _variables.inputDisabledBackgroundColor, ";"), " ", isHidden && "\n    opacity: 0;\n  ", " ", isDisplayingPlaceholder && /*#__PURE__*/(0, _core.css)("color:", _variables.inputPlaceholderTextColor, ";"), " ", hasIconLeft && _ref11, " ", iconAppearance === 'inside' && (iconPosition === 'right' ? /*#__PURE__*/(0, _core.css)("padding-right:40px;&::after{display:block;height:40px;width:40px;position:absolute;right:0;bottom:0;top:0;content:' ';background-color:", _feBrary.tokens.colors.neutral.surface.default, ";}") : /*#__PURE__*/(0, _core.css)("padding-left:40px;&::before{display:block;height:40px;width:40px;position:absolute;left:0;bottom:0;top:0;content:' ';background-color:", _feBrary.tokens.colors.neutral.surface.default, ";}")), " ", hasFloatingLabel && /*#__PURE__*/(0, _core.css)(floatingLabel, ";"));
};
exports.valueRenderer = valueRenderer;